<div class="flex flex-col gap-4 p-4 min-w-[300px]">
  <div class="flex items-start gap-3">
    @if (isUnrecoverable) {
      <mat-icon class="text-red-500 text-[32px] !w-8 !h-8">error</mat-icon>
      <div class="flex-1">
        <h3 class="m-0 mb-1 text-base font-medium">Ett fel har uppstått</h3>
        <p class="m-0 text-sm text-black/60">Sidan måste laddas om för att fortsätta fungera.</p>
      </div>
    } @else {
      <mat-icon class="text-primary text-[32px] !w-8 !h-8">system_update</mat-icon>
      <div class="flex-1">
        <h3 class="m-0 mb-1 text-base font-medium">Uppdatering tillgänglig</h3>
        <p class="m-0 text-sm text-black/60">En ny version av Attendo Nära finns tillgänglig.</p>
      </div>
    }
  </div>
  <div class="flex justify-end gap-2">
    @if (!isUnrecoverable) {
      <button mat-button (click)="dismiss()">Senare</button>
    }
    <button mat-flat-button [color]="isUnrecoverable ? 'warn' : 'primary'" (click)="update()">
      {{ isUnrecoverable ? 'Ladda om' : 'Uppdatera nu' }}
    </button>
  </div>
</div>
